/**
 * Query keys for the send-preview surface.
 *
 * The gate at `src/test/staleAfterSaveGate.test.ts` requires every
 * `queryKey: [...]` literal to live in a `*Keys` file. This one holds a single
 * key, and it deliberately reuses the SAME `["profile", id]` shape the profile
 * pages already read under — so a specialist who corrects their signature email
 * on the profile screen sees the corrected reply-to in the next send preview,
 * without this surface having to know that happened.
 */
export const sendPreviewKeys = {
  all: ["profile"] as const,
  /** The acting user's own profile — the source of the outbound identity. */
  senderIdentity: (userId: string) => ["profile", userId] as const,
};
